module.exports = __webpack_public_path__ + "static/media/request_behalf_left.975c666c.png";